export default "/assets/images/technology-graph-06.jpg?c9c1cec5413d797298e34621fb0b2cc4";